module.exports = __webpack_public_path__ + "commiliaPointsToHint.svg?42f1cfc04fc58b2b6d5522ab27dae0d5";